import styled from "styled-components";


export const ContainerStyles = styled.div`
  
  display:flex;
  justify-content:space-around;
  @media (max-width:700px) {
    flex-direction:column;
    align-items:center;
  }
`